module.exports = __webpack_public_path__ + "static/media/11NEPAD7.15e7b542.jpg";